import React from 'react'
import AdminActionsContainer from 'redux/containers/pages/precedentscontent/AdminActionsContainer'
import { PrecedentDownloadButton } from 'pages/documentscontent/Item'
import TealToolTip from 'components/TealToolTip'
import getUrl from 'front-end-core/core/url'
import { PRECEDENTS_CONTENT } from 'constants/controllers'
import notificationToast from 'helpers/notificationToast'
import LinkIcon from '@material-ui/icons/Link'
import { toast } from 'react-toastify'
import Icon from 'components/shared/Icon'
import Selector from 'pages/documentscontent/Selector'
import { useSelector } from 'react-redux'
import selectAolName from 'redux/selectors/selectAolName'

const ItemActions = (props) => {
  const {
    isAdmin,
    id,
    view,
    sectionId,
    hiddenRef,
    selected = null,
    title,
    isLogged,
    setSignUpModalIsOpen
  } = props

  return (
    <div className='action-buttons flex items-center'>
      {isAdmin ? <AdminActionsContainer {...props} /> : null}
      <PrecedentLink {...{ id, view, sectionId }} />
      <PrecedentDownloadButton {...{ id, hiddenRef, isLogged, setSignUpModalIsOpen }} />
      <PrecedentSelector {...{ id, selected, title, isLogged }} />
    </div>
  )
}

const PrecedentLink = ({ id: precedentId, view, sectionId }) => {
  const aol = useSelector(selectAolName)

  return (
    <TealToolTip title='Copy link to clipboard'>
      <a
        href={null}
        className='pointer mh2'
        data-clipboard-text={getUrl(PRECEDENTS_CONTENT, { aol, view, sectionId, precedentId }, {}, true)}
        onClick={() => notificationToast(<LinkIcon />, toast.TYPE.INFO, 'Link copied to clipboard')}
      >
        <Icon className='w6 black' name='icon-link-variant' />
      </a>
    </TealToolTip>
  )
}

const PrecedentSelector = ({ selected, id, title }) => {
  return !selected !== null && (
    <Selector
      ids={id}
      selected={selected}
      data-help-item='precedentsselection'
      data-help-position='left'
      data-event-category='Accordion'
      data-event-action={selected ? 'Deselect' : 'Select'}
      data-event-label={title}
    />
  )
}

export default ItemActions
